import React, { useState } from "react";
import {
  Col,
  Row,
  Button,
  Form,
  Input,
} from "antd";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { Post } from "../../config/api/post";
import { USER_AUTH } from "../../config/constants/api";
import swal from "sweetalert";

function AddUser() {
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.userToken);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = (values) => {
    const { firstName, lastName, email, phone, password } = values;

    const formData = {
      firstName,
      lastName,
      email,
      phone,
      password,
      isAdmin: false,
    };

    setLoading(true);

    Post(USER_AUTH.signup, formData, token)
      .then((response) => {
        setLoading(false);
        if (response?.status) {
          swal("Success", "User added successfully", "success");
          navigate("/userManagement");
        } else {
          swal("Error", response?.message || "Something went wrong", "error");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("Error", err);
        const errorMessage =
          err?.response?.data?.message ||
          err?.message ||
          "Something went wrong";
        swal("Error", errorMessage, "error");
      });
  };

  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div className="flex justify-between items-center mt-8">
          <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black ml-8">
            Add User
          </h3>
        </div>
        <div
          className="bg-white rounded-lg py-8 my-8"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <Row style={{ padding: "20px 40px" }}>
            <Col xs={24}>
              <Form
                form={form}
                layout="vertical"
                name="addUserForm"
                onFinish={onFinish}
              >
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="firstName"
                      label={
                        <p className="font-euclid text-sm text-[#34324B]">
                          First Name
                        </p>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Please enter first name!",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter First Name"
                        className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="lastName"
                      label={
                        <p className="font-euclid text-sm text-[#34324B]">
                          Last Name
                        </p>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Please enter last name!",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter Last Name"
                        className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="email"
                      label={
                        <p className="font-euclid text-sm text-[#34324B]">
                          Email
                        </p>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Please enter email!",
                        },
                        {
                          type: "email",
                          message: "Please enter a valid email!",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter Email"
                        className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="phone"
                      label={
                        <p className="font-euclid text-sm text-[#34324B]">
                          Phone Number
                        </p>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Please enter phone number!",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter Phone Number"
                        className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="password"
                      label={
                        <p className="font-euclid text-sm text-[#34324B]">
                          Password
                        </p>
                      }
                      rules={[
                        {
                          required: true,
                          message: "Please enter password!",
                        },
                        {
                          min: 6,
                          message: "Password must be at least 6 characters!",
                        },
                      ]}
                    >
                      <Input.Password
                        placeholder="Enter Password"
                        className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item
                      name="confirmPassword"
                      label={
                        <p className="font-euclid text-sm text-[#34324B]">
                          Confirm Password
                        </p>
                      }
                      dependencies={["password"]}
                      rules={[
                        {
                          required: true,
                          message: "Please confirm password!",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue("password") === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("Passwords do not match!")
                            );
                          },
                        }),
                      ]}
                    >
                      <Input.Password
                        placeholder="Confirm Password"
                        className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16} style={{ marginTop: "20px" }}>
                  <Col xs={24}>
                    <div style={{ display: "flex", gap: "10px" }}>
                      <Button
                        type="default"
                        htmlType="button"
                        size="large"
                        className="uppercase font-euclid font-bold"
                        onClick={() => navigate("/userManagement")}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        loading={loading}
                        className="uppercase bg-button text-black font-euclid font-bold"
                        style={{
                          backgroundColor: "#E8C778",
                          color: "black",
                          border: "none",
                        }}
                      >
                        Add User
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
}

export default AddUser;

